<template>
	<div>
		<van-overlay :show="showOverlay" z-index="99">
			<div style="position: fixed; top: 50%; left: 50%; z-index: 100; transform: translate(-50%, -50%)"></div>
		</van-overlay>
		<section class="c" :class="is_web_css" :style="{ minHeight: windowHight }">
			<div class="jianbian">
				<van-form ref="formAddorEdit" class="fromClass">
					<van-field v-model="formData.redeemCode" label="充值码：" placeholder="请输入充值码" :rules="rules.redeemCode" />
					<div style="margin: 16px">
						<span class="buttonSpan" @click="butClick">确认充值</span>
					</div>
				</van-form>
			</div>
		</section>
	</div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import axios from 'axios';

export default {
	data() {
		return {
			showOverlay: true, //遮罩
			is_web_css: '',
			// activityId: this.$route.query.id, //活动详情ID
			activityId: '4908266334414f06a223c66f263a3d9e', //正式环境
			// activityId: '38771ae262da408f86ddc0ed206e2ac8', //测试环境
			aiId: '',
			token: '',
			formData: { redeemCode: '' },
			rules: { redeemCode: [{ required: true }] },

			windowHight: '100vh',
		};
	},

	mounted() {
		document.title = '点数充值';
		Toast.loading({
			message: '加载中...',
			duration: 0,
		});
		if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			this.getToken();
			let that = this;
			this.$bridge.registerhandler('refreshList', () => {
				that.getToken();
			});
			// this.token = this.$route.query.webToken;
			// this.getActivityId();
		} else {
			this.token = this.$route.query.webToken;
			this.getActivityId();
			this.is_web_css = 'is_web_css';
		}
	},
	methods: {
		// 获取token
		getToken() {
			let that = this;
			if (navigator.userAgent.indexOf('kcgy') == -1) {
				window.location.href = 'https://app.kcguoyi.com/download/#/';
				return false;
			}
			this.$bridge.callHandler('loadToken', null, (response) => {
				if (response == '' || response.length <= 0) {
					that.$bridge.callHandler('login', null, function (response) {});
					return false;
				}
				that.token = response;
				that.getActivityId();
			});
		},
		//根据活动的详情页ID显示数据
		async getActivityId() {
			var url = process.env.VUE_APP_BASE_API + '/act/page/h5/' + this.activityId;
			await axios.get(url, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5', clientOs: 'h5' } }).then(async (res) => {
				if (res.data.code != 200) return false;
				//判断活动是否有效及时间范围内
				var actStartTime = new Date(res.data.data.actStartTime.replace(/-/g, '/')).getTime();
				var actEndTime = new Date(res.data.data.actEndTime.replace(/-/g, '/')).getTime();
				var myDate = new Date().getTime();
				var actStatusCode = res.data.data.actStatusCode; //0 活动正常 1活动不正常
				this.aiId = res.data.data.aiId;
				this.showOverlay = false; //不显示遮罩
				this.windowHight = window.innerHeight + 'px';
				if (this.is_web_css == '') {
					if (myDate < actStartTime || myDate > actEndTime || actStatusCode == '1') {
						this.$router.replace('/defaultPage');
						return false;
					}
				}
				Toast.clear();
			});
		},

		//表单的提交
		butClick() {
			this.$refs.formAddorEdit
				.validate()
				.then(() => {
					var url = process.env.VUE_APP_BASE_API + '/act/questionnaire/h5/submitTongueRecharge';
					// var lableData = ['充值码'];
					var newJson = {
						aiId: this.aiId,
						...this.formData,
						// tableHead: lableData.toString(),
					};

					if (this.formData.redeemCode.trim() == '') {
						Toast('请填写充值码！');
						return false;
					}
					axios.post(url, newJson, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }).then((res) => {
						if (res.data.code == 200) {
							Dialog({ message: '充值操作成功，点数将会在24小时自动到账' });
						} else {
							Dialog({ message: res.data.msg });
						}
					});
				})
				.catch(() => {
					Toast('请填写完整信息');
				});
		},
	},
};
</script>
<style lang="scss" >
section {
	min-height: 100vh;
	overflow: hidden;
	background-image: url('../image/aisz_back.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	// padding-bottom: 10px;
	position: relative;
}
.c {
	width: 100%;
}
.is_web_css {
	max-width: 375px;
	max-height: 667px;
	margin: 50px auto;
}
.jianbian {
	width: 90%;
	overflow: hidden;
	padding: 28px 10px;
	background-image: url('../image/aisz_smallBox.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;

	position: absolute;
	top: 60%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.fromClass {
	width: 100%;
	// background-color: #ffffff;
	margin: 0 auto;
	border-radius: 10px;
	overflow: hidden;
	padding-top: 15px;
	.van-cell {
		background-color: transparent;
	}
	.van-cell::after {
		border: 0;
	}
	.van-field__label {
		width: 5em;
		line-height: 34px;
		font-size: 13px;
		color: #222222;
		text-align: right;
	}
	.van-field__value {
		overflow: visible;
		// border: 1px solid #b2b2b2;
		padding-left: 10px;
		// border-radius: 8px;
		height: 34px;
		line-height: 34px;
		background-color: #c8fafb;
		border-radius: 7px;
		border: 1px solid #38a0ad;
	}

	.buttonSpan {
		width: 100%;
		display: block;
		text-align: center;
		margin: 0 auto;
		height: 35px;
		line-height: 35px;
		background-color: #046c6e;
		border-radius: 19px;
		font-size: 14px;
		color: #ffffff;
		// border-radius: 8px;
	}
}
</style>